export default __webpack_public_path__ + "static/media/Recruiter.81930cf4.svg";